firebird.factory('meetingMomentsService', [
    'meetingService',
    '$window',
    'timeZoneService',
    function (meetingService, $window, timeZoneService) {
        service = {
            getStartTime: getStartTime,
            getEndTime: getEndTime,
            getCurrentTime: getCurrentTime,
            getTicksBeforeScheduledStart: getTicksBeforeScheduledStart
        };

        return service;

        function getTimeZone() {
            var timezone = meetingService.getTimeZoneId();
            if (!timezone) {
                var timezoneDisplayname = meetingService.getTimeZone();
                timezone = timeZoneService.convertToTimezoneObj(timezoneDisplayname);
            }

            return timezone;
        }

        // meeting scheduled start time
        function getStartTime() {
            var rawTime = meetingService.getStartTime();
            var timezone = getTimeZone();
            return $window.moment.tz(rawTime, timezone);
        }

        // meeting scheduled end time
        function getEndTime() {
            var rawTime = meetingService.getEndTime();
            var timezone = getTimeZone();
            return $window.moment.tz(rawTime, timezone);
        }

        function getCurrentTime() {
            return $window.moment();
        }

        function getTicksBeforeScheduledStart() {
            return getStartTime() - getCurrentTime();
        }
    }
]);
